<form [formGroup]="goals_form" autocomplete="off">
    <div formGroupName="goal" class="goals-form">
        <mat-form-field>
            <mat-label>{{ "Goal title" | translate }}</mat-label>
            <input 
                matInput
                placeholder="{{ 'Goal title' | translate }}"
                formControlName="name"
                required
            />
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ "Due date" | translate }}</mat-label>
            <input 
            *ngIf="action != goalButtonActions.UPDATE"
                matInput
                formControlName="due"
                [matDatepicker]="goalpicker"
                (click)="goalpicker.open()"
                (focus)="goalpicker.open()"
                required
                [min]="getMinDate()"
            />
            <input 
            *ngIf="action == goalButtonActions.UPDATE"
                matInput
                formControlName="due"
                [matDatepicker]="goalpicker"
                (click)="goalpicker.open()"
                (focus)="goalpicker.open()"
                required
            />
            <mat-hint>{{ "MM/DD/YYYY" | translate }}</mat-hint>
            <mat-datepicker-toggle 
                matSuffix 
                [for]="goalpicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #goalpicker></mat-datepicker>
            <mat-error>{{"Please use a later date." | translate}}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ "Description" | translate }}</mat-label>
            <textarea 
                matInput
                formControlName="description"
                [placeholder]=""
            >
            </textarea>
        </mat-form-field>
    </div>

    <div class="tasks-container-mobile" fxShow fxHide.gt-xs>
        <div class="tasks-header">
            <h3 class="task-header-text">{{ "Tasks" | translate }}</h3>
            <p *ngIf="action != goalButtonActions.DELETE">{{ "One of more tasks are required to create a goal" | translate }}{{"*"}}</p>
        </div>

        <div class="tasks-action" *ngIf="action != goalButtonActions.DELETE">
            <mat-form-field class="task-input">
                <mat-label>{{ "Task" | translate }}</mat-label>
                <input 
                    matInput
                    placeholder="{{ 'Task' | translate }}"
                    [formControl]="newTaskName"
                    required
                />
            </mat-form-field>
            <div class="task-input-row">
                <mat-form-field class="task-date-input">
                    <mat-label>{{ "Due date" | translate }}</mat-label>
                    <input 
                    *ngIf="action != goalButtonActions.UPDATE"
                        matInput
                        [formControl]="newTaskDueDate"
                        [matDatepicker]="taskpicker"
                        readonly
                        (click)="taskpicker.open()"
                        (focus)="taskpicker.open()"
                        required
                        [matDatepickerFilter]="dateFilter"
                    />
                    <input 
                    *ngIf="action == goalButtonActions.UPDATE"
                        matInput
                        [formControl]="newTaskDueDate"
                        [matDatepicker]="taskpicker"
                        readonly
                        (click)="taskpicker.open()"
                        (focus)="taskpicker.open()"
                        required
                    />
                    <!-- <mat-hint>{{ "MM/DD/YYYY" | translate }}</mat-hint> -->
                    <mat-datepicker-toggle matSuffix [for]="taskpicker"></mat-datepicker-toggle>
                    <mat-datepicker #taskpicker></mat-datepicker>
                    <mat-error>{{"Please input a later date that is before your due date." | translate}}</mat-error>
                </mat-form-field>
                <button 
                    mat-button 
                    class="btn-add-task" 
                    (click)="onAddTask($event)"
                    type="button"
                    style="padding: 0px"
                >
                    <mat-icon>add</mat-icon> {{ "Add task" | translate }}
                </button>
            </div>
        </div>

        <div formArrayName="tasks">
            <div 
                *ngFor="let task of formTasks.controls; let i = index" 
                class="tasks-list"
            >
                <app-goal-task 
                *ngIf="isFormGroup(task)"
                    [taskFormGroup]='task'
                    [taskId]="i" 
                    [taskName]="task.get('name')?.value" 
                    [taskDueDate]="task.get('due')?.value"
                    (deleteTask)="onDeleteTask(i)"
                    [action]="action"
                >
                </app-goal-task>
            </div>
        </div>
    </div>

    <!-- Desktop view -->
    <div class="tasks-container" fxHide fxShow.gt-xs>
        <div class="tasks-header">
            <h3 class="task-header-text">{{ "Tasks" | translate }}</h3>
            <p *ngIf="action != goalButtonActions.DELETE">{{ "One of more tasks are required to create a goal" | translate }}{{"*"}}</p>
        </div>

        <div class="tasks-action" *ngIf="action != goalButtonActions.DELETE">
            <mat-form-field class="task-input">
                <mat-label>{{ "Task" | translate }}</mat-label>
                <input 
                    matInput
                    placeholder="{{ 'Task' | translate }}"
                    [formControl]="newTaskName"
                    required
                />
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ "Due date" | translate }}</mat-label>
                <input 
                    *ngIf="action != goalButtonActions.UPDATE"
                        matInput
                        [formControl]="newTaskDueDate"
                        [matDatepicker]="taskpicker"
                        readonly
                        (click)="taskpicker.open()"
                        (focus)="taskpicker.open()"
                        required
                        [matDatepickerFilter]="dateFilter"
                    />
                    <input 
                    *ngIf="action == goalButtonActions.UPDATE"
                        matInput
                        [formControl]="newTaskDueDate"
                        [matDatepicker]="taskpicker"
                        readonly
                        (click)="taskpicker.open()"
                        (focus)="taskpicker.open()"
                        required
                    />
                <!-- <mat-hint>{{ "MM/DD/YYYY" | translate }}</mat-hint> -->
                <mat-datepicker-toggle matSuffix [for]="taskpicker"></mat-datepicker-toggle>
                <mat-datepicker #taskpicker></mat-datepicker>
                <mat-error>{{"Please input a later date that is before your due date." | translate}}</mat-error>
            </mat-form-field>
            <button 
                mat-button 
                class="btn-add-task" 
                (click)="onAddTask($event)"
                type="button"
            >
                <mat-icon>add</mat-icon> {{ "Add task" | translate }}
            </button>

        </div>

        <div formArrayName="tasks">
            <div 
                *ngFor="let task of formTasks.controls; let i = index" 
                class="tasks-list"
            >
                <app-goal-task 
                *ngIf="isFormGroup(task)"
                    [taskFormGroup]='task'
                    [taskId]="i" 
                    [taskName]="task.get('name')?.value" 
                    [taskDueDate]="task.get('due')?.value"
                    (deleteTask)="onDeleteTask(i)"
                    [action]="action"
                >
                </app-goal-task>
            </div>
        </div>
    </div>
    <!-- end of desktop view -->

    <mat-dialog-actions align="end">
        <div class="actions">
            <button
                mat-button
                style="border-radius: 1000px; padding-inline: 2rem"
                color="basic"
                (click)="onCancelClick()"
            >
                {{ "Cancel" | translate }}
            </button>

            <button
                [disabled]="!isFormValid"
                mat-raised-button
                color="primary"
                (click)="buttonAction"
                style="border-radius: 1000px; padding-inline: 2rem"
                [class.deleteBtn]="action === goalButtonActions.DELETE"
            >
                {{ buttonText | translate }}
            </button>
        </div>
   </mat-dialog-actions>
</form>